import React from 'react';
import { Avatar, Button, makeStyles, Tab, Tabs } from '@material-ui/core';
import ArrowBack from '@material-ui/icons/ArrowBack';
import './Detail-View-Layout.scss';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { notificationManager } from '../../utils/NotificationUtils';
const DetailViewLayout = (props) => {
  const {
    onClickEdit,
    onClickBack,
    tabValue,
    handleTabChange,
    tabList,
    renderScreen,
    onViewToggle,
    title,
    isEditable,
    tabClass,
    isHeightIncluded,
    disableAvatar,
    copyDetails,
  } = props;

  const useStyles = makeStyles((theme) => ({
    largeAvatar: {
      width: theme.spacing(5),
      height: theme.spacing(5),
      backgroundColor: '#076c21',
    },
    tabs: {
      '& .MuiTabs-indicator': {
        display: tabList?.length > 1 ? 'block' : 'none',
      },
    },
  }));

  const classes = useStyles();

  const onClickEditButton = (e) => {
    return onClickEdit(e);
  };

  return (
    <>
        <div className='container mt-4 mb-3 detail-view-65 pb-4'>
          <div className='mt-5 row mx-0'>
            <div className='col-md-6 px-0 d-flex align-items-center'>
              <Button
                variant='text'
                color='secondary'
                size='small'
                startIcon={<ArrowBack />}
                onClick={(e) => {
                  onClickBack ? onClickBack() : onViewToggle(null, false, null);
                }}
                className='me-2'
              >
                Back
              </Button>
              <span className='page-title text-break'>{title}</span>
            </div>
            <div className='col-md-6  justify-content-end align-content-center'>
              {isEditable && (
                <Button
                  variant='outlined'
                  color='primary'
                  size='small'
                  className='float-end'
                  onClick={(e) => onClickEditButton(e)}
                >
                  Edit
                </Button>
              )}
              {copyDetails && (
                <Button
                  className='text-secondary'
                  variant='outlined'
                  color='secondary'
                  size='large'
                  onClick={(e) => {
                    notificationManager('success', 'Details Copied');
                  }}
                  endIcon={<ContentCopyIcon />}
                >
                  Copy Details
                </Button>
              )}
            </div>
          </div>
          <div className={`card shadow mt-4 mb-4 pb-5 ${isHeightIncluded && 'h-100 '} px-4`}>
            <div className='row d-flex mt-4'>
              <div className='col-md-11'>
                {tabList && (
                  <div className={tabClass ? tabClass : `col-md-12`}>
                    <Tabs
                      value={tabValue}
                      variant='fullWidth'
                      indicatorColor='primary'
                      onChange={handleTabChange}
                      aria-label='hotel-add-tabs'
                      textColor={tabList.length > 1 ? 'primary' : 'inherit'}
                      className={`property-tabs mt-4 ${classes.tabs}`}
                    >
                      {tabList.length && tabList.map((tab, key) => <Tab label={tab} key={key} />)}
                    </Tabs>
                  </div>
                )}
                <div className='col-md-12 detail-view'>{renderScreen()}</div>
              </div>         
            </div>
          </div>
        </div>
    </>
  );
};

export default DetailViewLayout;
